import PropTypes from 'prop-types';
import React from 'react';

const DownloadFilled = ({ width, height }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 19 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="download"
  >
    <path
      d="M11.8751 11.6202H10.3038V6.48214C10.3038 6.38884 10.2274 6.3125 10.1341 6.3125H8.86181C8.76851 6.3125 8.69217 6.38884 8.69217 6.48214V11.6202H7.12509C6.98302 11.6202 6.90456 11.7835 6.9915 11.8938L9.3665 14.8985C9.38237 14.9188 9.40264 14.9352 9.42579 14.9465C9.44893 14.9578 9.47434 14.9636 9.50009 14.9636C9.52584 14.9636 9.55125 14.9578 9.5744 14.9465C9.59754 14.9352 9.61782 14.9188 9.63369 14.8985L12.0087 11.8938C12.0956 11.7835 12.0172 11.6202 11.8751 11.6202Z"
      fill="white"
    />
    <path
      d="M15.8489 4.415C14.8777 1.85339 12.403 0.0318489 9.50424 0.0318489C6.60547 0.0318489 4.1308 1.85127 3.1596 4.41288C1.3423 4.89 0 6.54613 0 8.51399C0 10.8572 1.89788 12.7551 4.23895 12.7551H5.08929C5.18259 12.7551 5.25893 12.6787 5.25893 12.5854V11.3131C5.25893 11.2198 5.18259 11.1435 5.08929 11.1435H4.23895C3.52433 11.1435 2.85212 10.8593 2.35167 10.344C1.85335 9.83084 1.58828 9.13955 1.61161 8.42281C1.63069 7.86299 1.82154 7.33709 2.16719 6.8939C2.52132 6.44223 3.01752 6.11354 3.56886 5.96723L4.37254 5.75729L4.6673 4.98118C4.84967 4.4977 5.10413 4.04602 5.42433 3.63676C5.74044 3.23112 6.11489 2.87453 6.53549 2.57861C7.40703 1.96578 8.43337 1.64134 9.50424 1.64134C10.5751 1.64134 11.6015 1.96578 12.473 2.57861C12.895 2.87549 13.2682 3.23174 13.5842 3.63676C13.9044 4.04602 14.1588 4.49982 14.3412 4.98118L14.6338 5.75517L15.4354 5.96723C16.5847 6.27683 17.3884 7.32225 17.3884 8.51399C17.3884 9.21589 17.1148 9.8775 16.6186 10.3737C16.3753 10.6185 16.0858 10.8125 15.767 10.9447C15.4481 11.0768 15.1062 11.1444 14.761 11.1435H13.9107C13.8174 11.1435 13.7411 11.2198 13.7411 11.3131V12.5854C13.7411 12.6787 13.8174 12.7551 13.9107 12.7551H14.761C17.1021 12.7551 19 10.8572 19 8.51399C19 6.54825 17.6619 4.89424 15.8489 4.415Z"
      fill="white"
    />
  </svg>
);

DownloadFilled.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

DownloadFilled.defaultProps = {
  width: 19,
  height: 15,
};

export default DownloadFilled;
